import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, createVNode as _createVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "flex justify-center gap-2" }
const _hoisted_2 = { class: "flex justify-between items-center gap-2" }
const _hoisted_3 = { class: "flex flex-col items-center" }
const _hoisted_4 = {
  class: "basecolor-mr",
  style: {"margin-bottom":"8px"}
}
const _hoisted_5 = { class: "flex flex-col items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "basecolor-mr",
  style: {"margin-bottom":"8px"}
}, "Età", -1)
const _hoisted_7 = ["value"]
const _hoisted_8 = { class: "flex flex-col items-center" }
const _hoisted_9 = {
  key: 0,
  class: "flex flex-col items-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", {
  class: "basecolor-mr",
  style: {"margin-bottom":"8px"}
}, "Sesso", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("input", {
  class: "bg-gray-50 mb-4 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 basecolor-mr",
  style: {"width":"100px","text-align":"center"},
  placeholder: "1",
  disabled: "",
  value: "Maschile"
}, null, -1)
const _hoisted_12 = [
  _hoisted_10,
  _hoisted_11
]
const _hoisted_13 = {
  key: 1,
  class: "flex flex-col items-center"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", {
  class: "basecolor-mr",
  style: {"margin-bottom":"8px"}
}, "Sesso", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("input", {
  class: "bg-gray-50 mb-4 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 basecolor-mr",
  style: {"width":"100px","text-align":"center"},
  placeholder: "1",
  disabled: "",
  value: "Femminile"
}, null, -1)
const _hoisted_16 = [
  _hoisted_14,
  _hoisted_15
]
const _hoisted_17 = { class: "flex flex-col items-center" }
const _hoisted_18 = { class: "flex justify-center items-center mb-4" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_20 = { style: {"padding-bottom":"1rem"} }
const _hoisted_21 = {
  class: "text-sm text-center",
  style: {"color":"#1a576a"}
}
const _hoisted_22 = /*#__PURE__*/_createElementVNode("span", null, "Equazione utilizzata:", -1)
const _hoisted_23 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

import BaseOutput from "../components/BaseOutput.vue";
import BaseButtons from "../components/BaseButtons.vue";
import BaseInput from "../components/BaseInput.vue";
import {ref} from "vue";
import { patientStore } from "@/store/patient";
import { storeToRefs } from "pinia";


export default /*#__PURE__*/_defineComponent({
  __name: 'equazioneCalculator',
  props: {
    creatininemia: {},
    sesso: {},
    eta: {}
  },
  setup(__props: any) {

const props = __props;



let creatininemia = ref();
let result = ref("...");
const store = patientStore();
const { patient } = storeToRefs(store);
let creatinemiaValid = ref("");
let ethnicFactor:number = 1;
let sexFactor:number = 1;

function checkInputValidity() {
  if (creatininemia.value < 0.1 || creatininemia.value > 13) {
    creatinemiaValid.value =
    "Controlla il valore inserito. I valori sono compresi tra 0.1 e 13";
  } else {
    creatinemiaValid.value = "";
  }
}

function eraser (field) {
  field.value = ""
}

function resetForm() {
  eraser(creatinemiaValid);
  eraser(creatininemia);
  result.value = "...";
  document.getElementById("default-radio-1")!.checked = false;
  ethnicFactor = 1;
}

function calculator() {
  let k:number;
  let a:number;
  if (props.sesso == "unknown") {
   alert("Si prega di aggiornare il sesso");
  } else if (props.sesso == "male") {
    k = 0.9;
    a = -0.411;
  } else if (props.sesso == "female") {
    k = 0.7;
    a = -0.329;
    sexFactor = 1.018;
  }

  creatininemia.value = (isNaN(creatininemia.value) || creatininemia.value < 0.1) ? 1 : creatininemia.value;
  checkInputValidity()

  result.value = 141 * Math.pow(Math.min(creatininemia.value / k, 1), a) * Math.pow(Math.max(creatininemia.value / k, 1), -1.209) * Math.pow(0.993, props.eta) * sexFactor * ethnicFactor; 
  result.value = parseInt(result.value);
}

function etniaAfricana(event: Event) {
  const target = event.target as HTMLInputElement;
  ethnicFactor = target.checked ? 1.159 : 1;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('Etnia africana')), 1),
          _createElementVNode("input", {
            id: "default-radio-1",
            type: "checkbox",
            style: {"margin-left":"-5em"},
            class: "checkbox-custom",
            onClick: etniaAfricana
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _createElementVNode("input", {
            class: "bg-gray-50 mb-4 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500 basecolor-mr",
            style: {"width":"100px","text-align":"center"},
            placeholder: "1",
            disabled: "",
            value: _unref(patient).paziente_eta
          }, null, 8, _hoisted_7)
        ]),
        _createElementVNode("div", _hoisted_8, [
          (_unref(patient).paziente_sesso=='male')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_12))
            : _createCommentVNode("", true),
          (_unref(patient).paziente_sesso=='female')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_16))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(BaseInput, {
            label: "Creat. sierica mg/dL",
            type: "number",
            placeholder: "1",
            step: "0.1",
            lang: "it",
            modelValue: _unref(creatininemia),
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(creatininemia) ? (creatininemia).value = $event : creatininemia = $event)),
            onValidateInput: checkInputValidity,
            isInputValid: _unref(creatinemiaValid)
          }, null, 8, ["modelValue", "isInputValid"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _hoisted_19,
      _createVNode(BaseButtons, {
        hiddenSalvaButton: "",
        onClearForm: resetForm,
        onCalculate: calculator
      })
    ]),
    _createElementVNode("div", _hoisted_20, [
      _createVNode(BaseOutput, {
        class: "flex text-md basecolor-mr justify-center mb-2",
        label: _ctx.$t('GFR'),
        key: "number",
        result: _unref(result),
        unit: "mL/min/1.73 m²"
      }, null, 8, ["label", "result"]),
      _createElementVNode("p", _hoisted_21, [
        _hoisted_22,
        _createTextVNode(" GFR=141 * min(creatinina sierica / kappa, 1) alfa * max(creatinina sierica / kappa, 1) - 1.209 * 0.993 * Età * Sesso * Etnia"),
        _hoisted_23,
        _createTextVNode(" Dove i valori utilizzati sono stati: "),
        (_ctx.sesso == 'Femminile')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(" Sesso = 1; alpha = -0.411; kappa = 0.9; ")
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createTextVNode(" Sesso = 1.018; alpha = 0.329; kappa = 0.7; ")
            ], 64)),
        _createTextVNode(" Etnia = " + _toDisplayString(_unref(ethnicFactor)) + ". ", 1)
      ])
    ])
  ], 64))
}
}

})